import { createShadowFilter } from "./createShadowFilter";
import { Segment, Point } from "./types";
import { getContours } from "./getContours";
import * as contours from 'svg-path-contours';
import parse from './parseSvgPath';
import { loadSegments } from './loadSegments';
import { calculateVisibility } from './visibility';
export var generateSVGShadow = function (baseSvg, angle, options) {
    //Creation of shadow filter
    createShadowFilter(baseSvg);
    //Extraction of all shapes as points
    var lines = [];
    baseSvg
        .selectAll('path')
        .each(function (d, i, items) {
        var node = items[i];
        var points = contours(parse(node.getAttribute('d')));
        lines = lines.concat(points);
    });
    //Clipping all paths to the background-shape
    baseSvg
        .selectAll('path')
        .attr('clip-path', 'url(#background-clip)')
        .attr('filter', 'url(#icon-shadow)');
    //Transformation of points coordinates into shape segments
    var svgSegments = getContours(lines);
    //Creation of global walls to be able to compute the light area
    var allSegments = svgSegments.concat([
        new Segment(-10000, -10000, 10000, -10000),
        new Segment(10000, -10000, 10000, 10000),
        new Segment(10000, 10000, -10000, 10000),
        new Segment(-10000, 10000, -10000, -1000)
    ]);
    //Definition of light source location
    var lightXPos = Math.cos(angle) * 4999;
    var lightYPos = -Math.sin(angle) * 4999;
    var lightSource = new Point(lightXPos, lightYPos);
    var oppositeSource = new Point(500 - lightSource.x, 500 - lightSource.y);
    //Transformation of segments into endpoints from light POV
    var endpoints = loadSegments(allSegments, lightSource);
    //Computation of visible triangles
    var triangleParts = calculateVisibility(lightSource, endpoints);
    var lastPoint;
    //Building shape from visible triangles
    var path = 'M' + oppositeSource.x + ' ' + oppositeSource.y;
    triangleParts.forEach(function (item) {
        if (item[0].x > 0 && item[0].y > 0 && item[0].x < 500 && item[0].y < 500) {
            if (lastPoint !== undefined && (lastPoint.x !== item[0].x || lastPoint.y !== item[0].y)) {
                path = path + ' L' + oppositeSource.x + ' ' + oppositeSource.y;
            }
            path = path + ' L ' + item[0].x + ' ' + item[0].y;
        }
        if (item[1].x > 0 && item[1].y > 0 && item[0].x < 500 && item[0].y < 500) {
            path = path + ' L ' + item[1].x + ' ' + item[1].y;
            lastPoint = item[1];
        }
    });
    path = path + ' z';
    //Creating shadow area
    var shadowColor = options['shadow-path'] ? options['shadow-path'] : '#00768A';
    var shadow = baseSvg.insert('path', ':first-child')
        .attr('d', path)
        .attr('data-id', 'shadow-path')
        .attr('fill', shadowColor)
        .attr('clip-path', 'url(#background-clip)')
        .attr('style', 'stroke-width:2px; stroke:' + shadowColor + ';');
    shadow.on('click', function () {
        $('#scene').trigger('path:background-select', [shadow]);
    });
    //Creation of base background shape that will represent the clipped area
    var backCircle = baseSvg
        .insert('circle', ':first-child')
        .attr('cx', 250)
        .attr('cy', 250)
        .attr('r', 250)
        .attr('data-id', 'background-circle')
        .attr('fill', options['background-circle'] ? options['background-circle'] : '#0094AD');
    backCircle.on('click', function () {
        $('#scene').trigger('path:background-select', [backCircle]);
    });
    //Creation of the global clip
    var backgroundClip = baseSvg
        .append('clipPath')
        .attr('id', 'background-clip');
    backgroundClip
        .append('circle')
        .attr('cx', 250)
        .attr('cy', 250)
        .attr('r', 250)
        .attr('fill', 'white');
};
